import BaseModel from "./BaseModel";

export default class CandidateCourseModel extends BaseModel {
  private __title?: string;
  private __stepsCompleted?: number;
  private __totalSteps?: number;
  private __courseProgress?: number;

  constructor(arg: any) {
    super(arg);
    this.__title = arg.title;
    this.__stepsCompleted = arg.steps_completed;
    this.__totalSteps = arg?.total_steps ?? arg?.steps_total;
    this.__courseProgress = arg?.course_progress ?? arg?.last_step;
  }

  get title() {
    return this.__title || "";
  }
  get stepsCompleted() {
    return this.__stepsCompleted || 0;
  }
  get totalSteps() {
    return this.__totalSteps || 0;
  }
  get courseProgress() {
    return this.__courseProgress || 0;
  }
  get courseCompleted() {
    return this.__stepsCompleted === this.__totalSteps;
  }
}
